<latch-toast
  [ngClass]="{ 'active': showToast }"
  [show]="showToast"
  [type]="ToastType.WARNING"
  title="Protect your account"
  bodyText="Set up multi-factor authentication to add extra security to your account."
  [actions]="actions"
  (dismiss)="hideToast()"
></latch-toast>
